<template>
	<div>
		<div class="search-box" v-if="searchData.length > 0">
			<div class="line-box" v-for="(item, index) in searchData" :key="index">
				<div :class="getClass(index2, item2)" v-for="(item2, index2) in item" :key="item2.key"
					:style="item2.flex ? `flex: ${item2.flex}` : 'flex: 1'">
					<template v-if="item2.label||item2.type==='cascader2'||item2.type==='cascader3'">
						<div class="label" v-if="item2.label"><span v-if="item2.required"
								style="color: red;margin-right: 4px">*</span>{{ item2.label }}: </div>
						<el-input v-if="item2.type === 'input'" v-model="params[item2.key]"
							:placeholder="item2.placeholder?item2.placeholder:'请输入'" size="small"
							@keyup.enter.native="submitSearch"
							:clearable="item2.clearable === undefined?true:item2.clearable"
							@input="(val)=>{setParam(item2.key, val)}">
						</el-input>
						<el-select v-else-if="item2.type === 'select'"
						 :filterable="item2.filterable"
						 v-model="params[item2.key]"
							:placeholder="item2.placeholder?item2.placeholder:'请选择'" size="small"
							:clearable="item2.clearable === undefined?true:item2.clearable" :multiple="item2.multiple"
							@change="(val)=>{setParam(item2.key, val, true)}">
							<el-option v-for="option in item2.option" :key="option.value" :label="option.label"
								:value="option.value">
							</el-option>
						</el-select>
						<remote-select v-else-if="item2.type === 'remoteSelect'" v-model="params[item2.key]"
							:placeholder="item2.placeholder?item2.placeholder:'请选择'" size="small"
							:clearable="item2.clearable === undefined?true:item2.clearable" :multiple="item2.multiple"
							:label-field="item2.labelField" :search-field="item2.searchField"
							:value-field="item2.valueField" :remote-url="item2.remoteUrl"
							@change="(val)=>{setParam(item2.key, val, true)}">
						</remote-select>
						<custom-input v-else-if="item2.type==='customInput'" v-model="params[item2.key]"
							@input="(val)=>{setParam(item2.key, val, true)}"></custom-input>
						<link-select v-else-if="item2.type==='linkSelect'" v-model="params[item2.key]"
							:firstOptions="item2.option" :border="false" style="width: 100%"
							@change="(val)=>{setParam(item2.key, val, true)}"></link-select>
						<el-date-picker v-else-if="item2.type === 'date'"
							:clearable="item2.clearable === undefined?true:item2.clearable" v-model="params[item2.key]"
							:placeholder="item2.placeholder?item2.placeholder:'请选择'" size="small" @change="(val)=>{
                setParam(item2.key, val, true)
                if(item2.change){
                  item2.change(val)
                }
              }" :type="item2.option && item2.option.type?item2.option.type:'date'"
							:picker-options="item2.option?item2.option:{}" value-format="timestamp">
						</el-date-picker>
						<div class="date-range-c" v-else-if="item2.type === 'morerange'">
							<div class="rangs">
								<div :class="rangeType=='day'?'s-day':'u-day'" @click="sRangeType('day')">日</div>
								<div :class="rangeType=='week'?'s-range':'u-range'" @click="sRangeType('week')">周</div>
								<div :class="rangeType=='month'?'s-range':'u-range'" @click="sRangeType('month')">月
								</div>
								<div :class="rangeType=='year'?'s-range':'u-range'" @click="sRangeType('year')">年</div>
								<div :class="rangeType=='others'?'s-others':'u-others'" @click="sRangeType('others')">
									自定义</div>
							</div>
							<!-- 日 -->
							<el-date-picker v-if="rangeType=='day'" v-model="selectDay" type="date" placeholder="选择日期"
								@change="(val)=>{
							  setParam(item2.key, val?val:[], true,'day')
							  if(item2.change){
							    item2.change(val)
							  }
							}">
							</el-date-picker>
							<!-- 周 -->
							<el-date-picker v-if="rangeType=='week'" v-model="selectWeek" type="week"
								format="yyyy 第 WW 周" placeholder="选择周" @change="(val)=>{
								  setParam(item2.key, val?val:[], true,'week')
								  if(item2.change){
								    item2.change(val)
								  }
								}">
							</el-date-picker>
							<!-- 月 -->
							<el-date-picker v-if="rangeType=='month'" v-model="selectMonth" type="month"
								placeholder="选择月" @change="(val)=>{
						  setParam(item2.key, val?val:[], true,'month')
						  if(item2.change){
						    item2.change(val)
						  }
						}">
							</el-date-picker>
							<!-- 年 -->
							<el-date-picker v-if="rangeType=='year'" v-model="selectYear" type="year" placeholder="选择年"
								@change="(val)=>{
							  setParam(item2.key, val?val:[], true,'year')
							  if(item2.change){
							    item2.change(val)
							  }
							}">
							</el-date-picker>
							<!-- 自定义 -->
							<el-date-picker v-if="rangeType=='others'" v-model="selectOtherDay" type="daterange"
								align="right" unlink-panels range-separator="至" start-placeholder="开始日期"
								end-placeholder="结束日期" @change="(val)=>{
						  setParam(item2.key, val?val:[], true,'others')
						  if(item2.change){
						    item2.change(val)
						  }
						}">
							</el-date-picker>
						</div>
						<el-date-picker v-else-if="item2.type === 'daterange' || item2.type === 'monthrange'"
							:clearable="item2.clearable === undefined?true:item2.clearable" v-model="params[item2.key]"
							:placeholder="item2.placeholder?item2.placeholder:'请选择'" :unlink-panels="true" size="small"
							@change="(val)=>{
						  setParam(item2.key, val?val:[], true)
						  if(item2.change){
						    item2.change(val)
						  }
						}" :type="item2.type" range-separator="至" :picker-options="item2.option?item2.option:{}"
							value-format="timestamp">
						</el-date-picker>
						<el-cascader v-else-if="item2.type === 'cascader'" v-model="params[item2.key]"
							:placeholder="item2.placeholder?item2.placeholder:'请选择'" size="small"
							@change="(val)=>{setParam(item2.key, val, true)}" :options="item2.option"
							:props="{multiple: !!item2.multiple, checkStrictly: !!item2.checkStrictly,
							value:item2.valuePro, label: item2.labelPro}"
							:clearable="item2.clearable === undefined?true:item2.clearable">
						</el-cascader>
						<cascade-select v-else-if="item2.type === 'cascader2'" v-model="params[item2.key]"
							:placeholder="item2.placeholder?item2.placeholder:'请选择'" size="small"
							@change="(val)=>{setParam(item2.key, val, true)}" :select-option="item2.option.selectOption"
							:search-option="item2.option.searchOption">
						</cascade-select>
						<cascade-select2 v-else-if="item2.type === 'cascader3'" v-model="params[item2.key]"
							:placeholder="item2.placeholder?item2.placeholder:'请选择'" size="small"
							@change="(val)=>{setParam(item2.key, val, true)}" :select-option="item2.option.selectOption"
							:data="item2.data">
						</cascade-select2>

						<amount-range v-else-if="item2.type === 'amountrange'" v-model="params[item2.key]"
							@keyup.enter.native="submitSearch" @input="(val)=>{setParam(item2.key, val)}" />
					</template>
				</div>
				<div class="input2" v-if="index === searchData.length - 1">
					<div class="search-button">
						<div class="btn-item margin-r-16" @click="refreshSearch">
							<svg-icon icon-class="refresh_2" />
							<click-button is-text @click="refreshSearch" text="刷新"></click-button>
						</div>
						<div class="btn-item margin-r-16" @click="resetSearch">
							<svg-icon icon-class="reset" />
							<click-button is-text @click="resetSearch" text="重置"></click-button>
						</div>
						<div class="btn-item margin-r-16" v-if="isDownload" @click="exportFile">
							<svg-icon icon-class="search-export" />
							<click-button is-text @click="exportFile" text="导出" :color="'#3371FF'"></click-button>
						</div>
						<!--          <el-button type="default" size="small" @click="resetSearch" class="default-button">重 置</el-button>-->
						<!-- <el-button type="default" size="small" @click="exportFile" class="default-button" v-if="isDownload">导 出</el-button> -->
						<!--          <el-button type="primary" size="small" @click="submitSearch" class="default-button">查 询</el-button>-->
						<toggle-button @toggleHandler="toggleHandler" :default-is-stow="isStow"
							v-if="searchProps.length > nums - 1" />
					</div>
				</div>
			</div>
		</div>
	</div>

</template>

<script>
	import ToggleButton from "@/components/toggleButton";
	import AmountRange from "@/components/amountRange";
	import _ from "lodash"
	import RemoteSelect from "@/components/customForm/remoteSelect";
	import CustomInput from './customInput.vue';
	import CascadeSelect from "@/components/cascadeSelect/index.vue";
	import CascadeSelect2 from "@/components/cascadeSelect/index2.vue";
	import LinkSelect from '@/components/linkSelect'
	import ClickButton from "@/components/clickButton/index.vue";
	import CuTitle3 from "@/components/Title/cuTitle3.vue";

	export default {
		name: "searchGroup",
		components: {
			CuTitle3,
			ClickButton,
			CascadeSelect,
			RemoteSelect,
			AmountRange,
			ToggleButton,
			CustomInput,
			LinkSelect,
			CascadeSelect2
		},
		watch: {
			value: {
				handler(val) {
					this.params = _.cloneDeep(val)
				},
				deep: true
			},
			searchProps: {
				handler(val) {
					this.rebuildProps(this.searchProps)
				},
				deep: true
			},
		},
		props: {
			searchProps: {
				type: Array,
				default: () => {
					return []
				}
			},

			border: {
				type: Boolean,
				default: true
			},
			value: {
				type: Object,
				default: () => {
					return {}
				}
			},
			nums: {
				type: Number,
				default: 4
			},
			isDownload: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				searchData: [],
				isStow: false,
				params: _.cloneDeep(this.value),
				initParams: _.cloneDeep(this.value),
				show: false,
				shake: null,
				shakeClear: null,
				exportFile: null,
				rangeType: 'day', //day,week,month,year,others
				selectDay: "",
				selectWeek: "",
				selectMonth: "",
				selectYear: "",
				selectOtherDay: "",
				pickerOptions: {
					shortcuts: [{
						text: '最近一周',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近一个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近三个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
							picker.$emit('pick', [start, end]);
						}
					}]
				}
			}
		},
		computed: {
			getClass() {
				return (index2, item2) => {
					let className = (index2 + 1) % this.nums === 0 ? `${item2.cssClass ? item2.cssClass : 'input'}` :
						`${item2.cssClass ? item2.cssClass : 'input'}`
					if (this.border) {
						className += ' border'
					}
					return className
				}
			}
		},
		created() {
			this.rebuildProps(this.searchProps)
			this.exportFile = this.$tool.throttle(async () => {
				this.$emit("download", () => {
					this.show = true
				})
			}, 1000)
		},
		methods: {
			sRangeType(type) {
				this.rangeType = type
			},
			rebuildProps(searchProps) {
				let searchData = this.splitArr(searchProps, this.nums)
				let last = searchData[searchData.length - 1]
				let lastLength = last.reduce((accumulator, currentValue) => accumulator + (currentValue.flex ? currentValue
					.flex : 1), 0);
				if (lastLength <= this.nums - 1) {
					last = last.concat(Array(this.nums - 1 - lastLength).fill({
						cssClass: "input2"
					}))
					searchData.splice(searchData.length - 1, 1, last)
				} else {
					last = Array(this.nums - 1).fill({
						cssClass: "input2"
					})
					searchData.push(last)
				}
				this.searchData = searchData
			},
			// 分割数组
			splitArr(arr, num) {
				let result = []
				let newItem = []
				let currentLen = 0
				for (let i = 0; i < arr.length; i++) {
					if (currentLen < num) {
						newItem.push(arr[i])
						if (arr[i].flex) {
							currentLen += parseInt(arr[i].flex)
						} else {
							currentLen++
						}
					} else {
						result.push(newItem)
						newItem = []
						currentLen = 0
						newItem.push(arr[i])
						if (arr[i].flex) {
							currentLen += parseInt(arr[i].flex)
						} else {
							currentLen++
						}
					}
				}
				if (!this.$tool.empty(newItem)) {
					result.push(newItem)
				}
				return result
			},
			toggleHandler(val) {
				if (val.isStow) {
					this.rebuildProps(this.searchProps.slice(0, this.nums - 1))
				} else {
					this.rebuildProps(this.searchProps)
				}
				this.isStow = val.isStow
			},
			submitSearch(val) {
				this.$emit("search")
			},
			refreshSearch() {
				this.$emit("search", 'refresh')
			},
			resetSearch() {
				this.$emit("input", _.cloneDeep(this.initParams))
				this.$emit("search", "reset")
			},
			setParam(key, val, isSearch = false, rangeType) { //rangeType:day,week,month,year,others
				let day = ""
				let nextDay = ""
				if (rangeType == 'day') {
					console.log("日")
					day = this.timestampToDateTime(val, 0, 1, 0)
					nextDay = this.timestampToDateTime(val, 0, 1, 0)
					val = [day, nextDay, 'day']
				} else if (rangeType == 'week') {
					console.log("周")
					day = this.timestampToDateTime(val, 0, 1, -1)
					nextDay = this.timestampToDateTime(val, 0, 1, 5)
					val = [day, nextDay, 'week']
				} else if (rangeType == 'month') {
					console.log("月")
					day = this.timestampToDateTime(val, 0, 1, 0)
					nextDay = this.timestampToDateTime(val, 0, 1, 30)
					val = [day, nextDay, 'month']
				} else if (rangeType == 'year') {
					console.log("年")
					day = this.timestampToDateTime(val, 0, 1, 0)
					nextDay = this.timestampToDateTime(val, 0, 12, 30)
					val = [day, nextDay, 'year']
				} else if (rangeType == 'others') {
					console.log("自定义")
					day = this.timestampToDateTime(val[0], 0, 1, 0)
					nextDay = this.timestampToDateTime(val[1], 0, 1, 0)
					val = [day, nextDay, 'others']
				}
				console.log(key, val)
				this.params[key] = val
				this.$emit("input", _.cloneDeep(this.params))
				if (isSearch) {
					this.$emit("search")
				}
			},
			timestampToDateTime(timestamp, yearR, monthR, dayR) {
				const date = new Date(timestamp); // 转换为Date对象
				const year = date.getFullYear(); // 获取年份
				const month = (date.getMonth() + monthR).toString().padStart(2, '0'); // 获取月份并补零
				const day = (date.getDate() + dayR).toString().padStart(2, '0'); // 获取日期并补零
				const hours = date.getHours().toString().padStart(2, '0'); // 获取小时并补零
				const minutes = date.getMinutes().toString().padStart(2, '0'); // 获取分钟并补零
				const seconds = date.getSeconds().toString().padStart(2, '0'); // 获取秒钟并补零
				return `${year}-${month}-${day}`; // 拼接字符串返回
			},
			beforeEnter(el) {

			},
			enter(el, done) {
				this._offset = document.body.offsetHeight //激发重绘

				let downloadList = document.getElementById("download-list")
				let downButton = document.getElementById("down-button")
				let downloadListX = downloadList.getBoundingClientRect()
				let downButtonX = downButton.getBoundingClientRect()
				let x = downloadListX.left - downButtonX.left
				let y = downButtonX.top - downloadListX.top

				el.style.display = ''
				el.style.transform = `translateY(-${y}px)`

				let innerBall = el.querySelector('.innerBall')
				innerBall.style.transform = `translateX(${x}px)`
				innerBall.style.opacity = "0"
				el.addEventListener('transitionend', done)
			},
			afterEnter(el) {
				this.show = false
				el.style.display = 'none'

				this.setShake()

				el.style.transform = `translate(0, 0)`
				let innerBall = el.querySelector('.innerBall')
				innerBall.style.transform = `translate(0, 0)`
				innerBall.style.opacity = "1"

			},
			setShake() {
				clearInterval(this.shake)
				clearInterval(this.shakeClear)
				let f = 10
				this.shake = setInterval(() => {
					let downloadList = document.getElementById("download-list")
					downloadList.style.transform = `rotate(${f}deg)`
					downloadList.style.width = `24px`
					downloadList.style.height = `24px`
					f *= -1
				}, 150)
				this.shakeClear = setTimeout(() => {
					clearInterval(this.shake)
					let downloadList = document.getElementById("download-list")
					downloadList.style.transform = `rotate(0deg)`
					downloadList.style.width = `18px`
					downloadList.style.height = `18px`
				}, 2000)
			}
		}
	}
</script>


<style scoped lang="scss">
	::v-deep .el-cascader__tags {
		max-height: 26px;
		overflow-y: auto;
	}

	::v-deep .el-cascader__tags::-webkit-scrollbar {
		display: none;
	}

	.down-button {
		margin: 0 10px;
		position: relative;
	}

	.ball {
		position: absolute;
		z-index: 100;
		top: 0;
	}

	.date-range-c {
		display: flex;
		flex-direction: row;
		align-items: center;
	}

	.rangs {
		display: flex;
		flex-direction: row;
		align-items: center;
		margin-right: 10px;
	}

	.rangs div {
		width: 50px;
		text-align: center;
		height: 26px;
		line-height: 26px;
		font-size: 13px;
		font-weight: 400;
	}


	.s-day {
		color: #3371FF;
		border: 1px #3371FF solid;
		// border-radius: 10px 0 0 10px;
	}

	.u-day {
		color: #697B8C;
		border: 0.5px #DCDFE6 solid;
		// border-radius: 10px 0 0 10px;
	}


	.s-others {
		color: #3371FF;
		border: 1px #3371FF solid;
		// border-radius: 0 10px 10px 0;
	}

	.u-others {
		border: 0.5px #DCDFE6 solid;
		color: #697B8C;
		// border-radius: 0 10px 10px 0;
	}

	.s-range {
		border: 1px #3371FF solid;
		color: #3371FF;
	}

	.u-range {
		border: 0.5px #DCDFE6 solid;
		color: #697B8C;
	}






	.ball {
		width: 24px;
		height: 24px;
		transition: all 1s cubic-bezier(0.000, -0.190, 0.000, 0.970);
	}

	.innerBall {
		width: 24px;
		height: 24px;
		opacity: 1;

		svg {
			width: 24px;
			height: 24px;
		}

		transition: all 1s linear;
	}

	::v-deep .el-input__inner {
		height: 30px !important;
		border-radius: 0px;
		// border: none !important;
	}

	::v-deep .cus-cascade {
		border: unset;
	}

	::v-deep .el-icon-date {
		line-height: 26px;
		margin-top: 2px;
	}

	::v-deep .el-date-editor,
	.el-range-editor {
		line-height: 26px;
		margin-top: 2px;
	}

	::v-deep .el-range-separator {
		line-height: 26px;
		margin-top: 2px;
	}
</style>
<style lang="less">
	//条件搜索样式
	.search-box {
		background-color: white;
		padding-left: 10px;
		padding-right: 10px;
		padding-bottom: 10px;

		.line-box {
			padding-top: 10px;
			//padding-bottom:10px;
			display: flex;
			align-items: center;
			justify-content: flex-start;
			flex-wrap: wrap;

			>div:not(:last-child) {
				margin-right: 14px;
			}

			.input2 {
				flex: 1
			}

			.input {
				display: flex;
				//flex-direction: column;
				align-items: center;
				flex: 1;
				min-width: 0;
				position: relative;
				height: 32px;
				//background: rgba(255, 255, 255, .8);
				border-radius: 4px;

				//margin: 0 20px;
				.label {
					white-space: nowrap;
					font-size: 14px;
					font-weight: 400;
					color: #697B8C;
					text-align: left;
					margin-left: 10px;
					margin-right: 10px;
				}

				.el-input {
					width: 100%;
				}

				.el-date-editor,
				.el-range-editor {
					width: 100%;
				}

				.el-cascader {
					width: 100%;
				}
			}

			.border:not(.input2) {
				// border: 1px solid #DCDFE6;
			}
		}


	}

	.search-button {
		display: flex;
		justify-content: flex-end;
		flex: 1;

		.btn-item {
			display: flex;
			align-items: center;
			cursor: pointer;

			svg {
				width: 12px;
				height: 12px;
				margin-right: 4px;
			}
		}

		>div:last-child {
			margin-right: unset;
		}

	}


	.el-select {
		width: 100%;
	}
</style>